import PropTypes from 'prop-types'

export const ContentSection = ({
  title,
  subtitle,
  titleLevel = 'h2',
  children,
  variant = 'secondary',
  spacing = 'default',
  border = true,
  prose = false,
  className = '',
}) => {
  const getBackgroundClass = () => {
    switch (variant) {
      case 'primary':
        return 'bg-dark-primary'
      case 'secondary':
        return 'bg-dark-secondary'
      case 'tertiary':
        return 'bg-dark-tertiary'
      case 'transparent':
        return 'bg-transparent'
      default:
        return 'bg-dark-secondary'
    }
  }

  const getSpacingClass = () => {
    switch (spacing) {
      case 'none':
        return ''
      case 'compact':
        return 'p-4'
      case 'default':
        return 'p-8'
      case 'comfortable':
        return 'p-10'
      case 'spacious':
        return 'p-12'
      default:
        return 'p-8'
    }
  }

  const getTitleClass = () => {
    switch (titleLevel) {
      case 'h1':
        return 'text-3xl font-bold'
      case 'h2':
        return 'text-2xl font-semibold'
      case 'h3':
        return 'text-xl font-semibold'
      case 'h4':
        return 'text-lg font-medium'
      default:
        return 'text-2xl font-semibold'
    }
  }

  const TitleTag = titleLevel

  const containerClasses = [
    'rounded-lg',
    getBackgroundClass(),
    getSpacingClass(),
    border ? 'border border-dark-border' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const contentClasses = prose ? 'prose prose-invert max-w-none' : ''

  return (
    <div className={containerClasses}>
      {title && (
        <div className="mb-6">
          <TitleTag className={`text-white ${getTitleClass()}`}>{title}</TitleTag>
          {subtitle && <p className="text-gray-400 mt-2">{subtitle}</p>}
        </div>
      )}
      <div className={contentClasses}>{children}</div>
    </div>
  )
}

ContentSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'transparent']),
  spacing: PropTypes.oneOf(['none', 'compact', 'default', 'comfortable', 'spacious']),
  border: PropTypes.bool,
  prose: PropTypes.bool,
  className: PropTypes.string,
}

export default ContentSection
